import sha256 from 'crypto-js/sha256';

export const toHash = (value: string) => {
    const hashDigest = sha256(value).toString();
    return hashDigest;
};
